import {OnDestroy, OnInit} from '@angular/core';
import {AppStatus} from '../../@models/app-status';
import {StatusListener} from '../../status-listener';
import {Order} from '../../../shared-gen/Model/Orders/Order';
import {ProductBase} from '../../../shared-gen/Model/Products/ProductBase';
import {Product} from '../../../shared-gen/Model/Products/Product';
import {ProductFun} from '../../../shared/model/products/product.fun';
import {MenuFun} from '../../../shared/model/menus/menu.fun';
import {AppService} from '../../services/app.service';

export class CupPageBase extends StatusListener implements OnInit, OnDestroy {

	order: Order;
	productBases: ProductBase[] = [];

	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		this.order = status.deviceStatus.VendingStatus.Order;
	}

	back() {
		const returnCredit = false;
		this.app.nav.cancelOrder(returnCredit);
	}

	cancel() {
		const returnCredit = true;
		this.app.nav.cancelOrder(returnCredit);
	}

	findBase(product: Product): ProductBase {
		const baseID = ProductFun.getBaseID(product.ID);
		if (!this.productBases[baseID]) {
			this.productBases[baseID] = MenuFun.findProductBase(this.menu, product);
		}
		return this.productBases[baseID];
	}

	getSize(product: Product) {
		const baseID = ProductFun.getBaseID(product.ID);
		return product.ID.replace(baseID + '-', '');
	}
}
